import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import { mapGetters, mapActions } from 'vuex'
import commonMixin from '@/mixin/common'
import { saveItem } from '@/utils/storage'
import {getVcodeReg} from '@/api/server/auth'
export default {
  name: 'RegisterPage',
  mixins: [commonMixin],
  data () {
    return {
      agreement: true,
      loadingSignup: false,
      form: {
        phone: null,
        password: null,
        vcode: null,
        name: null,
        address: null
      },
      loadingVcode: false,
      counter: 0,
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent
  },
  computed: {
    vcodeStatus () {
      return  this.counter > 0
    },
    vcodeTips () {
        return this.counter > 0 ? `${this.counter} s` : '发送'
    }
  },
  methods: {
    ...mapActions({
      REGISTER: 'REGISTER'
    }),
    getCode () {
        let phone = this.form.phone
        if (!phone || !this.isPhone(phone)) {
            this.error('请正确填写手机号码')
            return false
        }
        this.loadingVcode = true
        let query = {
            phone: phone,
        }
        getVcodeReg(query).then(res => {
            this.loadingVcode = false
            if (res.code === 200) {
            this.countDown(60)
            } else {
            this.warning(res.message, 'bottom')
            }
        }).catch(err => {
            console.log(err)
            this.loadingVcode = false
        })
    },
    countDown (count) {
        this.counter = count - 1
        if (this.counter > 0) {
            setTimeout(() => {
                this.countDown(this.counter)
            }, 1000)
        } else {
            // resend
        }
    },
    onRegister () {
      let phone = this.form.phone
      let vcode = this.form.vcode
      let password = this.form.password
      let password_confirm = this.form.password_confirm
      let name = this.form.name
      let address = this.form.address
      // if (!phone || !this.isPhone(phone)) {
      //   this.error('请正确填写手机号码')
      //   return false
      // }
      if (!vcode) {
        this.error('请正确填写验证码')
        return false
      }
      if (!password) {
        this.error('请正确填写密码')
        return false
      }
      if (password.length < 6 || password.length > 16) {
        this.error('密码必须为6-16位字符')
        return false
      }
      if (password !== password_confirm) {
        this.error('两次密码不同请重新输入')
        return false
      }
      if (!name) {
        this.error('请输入姓名')
        return false
      }
      if (!address) {
        this.error('请输入收货地址')
        return false
      }
      let data = {
        phone: phone,
        vcode: vcode,
        password: password,
        name: name,
        address: address
      }
      this.loadingSignup = true
      this.REGISTER(data).then(res => {
        this.loadingSignup = false
        if (res.code === 200) {
          saveItem('phone', this.form.phone)
          this.success('注册成功')
          this.$router.push('/')
        } else {
          let msg = '注册失败'
          if (res.message) {
            msg = res.message
          }
          this.error(msg)
        }
      }).catch(err => {
        this.loadingSignup = false
        this.error(err.message, 'bottom')
      })
    },
    reset () {
      this.agreement = true,
      this.loadingSignup = false,
      this.form = {
        phone: null,
        password: null,
        vcode: null,
        name: null,
        address: null
      }
    },
    handleRoute (route) {
      if (route.name === 'register') {
        this.reset()
      }
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}